import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { ProtectedRoute } from './routes/protected-route';
import { ROUTES } from './routes/routes-config';
import { DashboardLayout } from './layout/dashboard-layout';
import { LoginPage } from './pages/login-page';
import { DashboardPage } from './pages/dashboard-page';
import { ProvinciasPage } from './pages/catalogos/provincias-page';
import { BalancePage } from './pages/balance-page';
import { MovementsPage } from './pages/movements-page';
import { AccountsByCuitPage } from './pages/accounts-by-cuit-page';
import { CompliancePage } from './pages/compliance-page';
import { MerchantsPage } from './pages/merchants-page';
import { AccountsBoPage } from './pages/accounts-bo-page';
import { LimitsPage } from './pages/limits-page';
import { ClosureStatusPage } from './pages/closure-status-page';
import { ReportsPage } from './pages/reports-page';
import { RegulatoryPackagesPage } from './pages/regulatory-packages-page';

/**
 * (Backfill automático — agregar descripción)
 *
 * @taskId T058
 * @taskId T059a
 * @taskId T059b
 * @taskId T061
 * @taskId T653
 * @taskId T657
 * @see functional/Specs/specs_cycle-2.md HU-27-BE
 * @see functional/Specs/specs_cycle-2.md HU-06-FE
 * @see functional/Specs/specs_cycle-2.md HU-13-FE
 * @see functional/Specs/specs_cycle-2.md HU-07-FE
 * @see functional/Cycles/cycle-5/tasks.md HU-29-FE
 * @see functional/Cycles/cycle-5/tasks.md HU-99-FE
 */
export function App() {
  const basename = window.location.pathname.startsWith('/flexy/') || window.location.pathname === '/flexy'
    ? '/flexy'
    : undefined;

  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path={ROUTES.LOGIN} element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>
            <Route path={ROUTES.DASHBOARD} element={<DashboardPage />} />
            <Route path={ROUTES.PROVINCIAS} element={<ProvinciasPage />} />
            <Route path={ROUTES.ACCOUNTS_BY_CUIT} element={<AccountsByCuitPage />} />
            <Route
              path={ROUTES.BALANCE}
              element={<Navigate to={ROUTES.ACCOUNTS_BY_CUIT} replace />}
            />
            <Route path={ROUTES.BALANCE_DETAIL} element={<BalancePage />} />
            <Route path={ROUTES.MOVEMENTS_DETAIL} element={<MovementsPage />} />
            <Route path={ROUTES.COMPLIANCE_DETAIL} element={<CompliancePage />} />
            {/* Ciclo 4 — HU-26-FE Merchants */}
            <Route path={ROUTES.MERCHANTS} element={<MerchantsPage />} />
            {/* Ciclo 4 — HU-27-FE Cuentas BO */}
            <Route path={ROUTES.ACCOUNTS_BO} element={<AccountsBoPage />} />
            {/* Ciclo 4 — HU-28-FE Límites BO */}
            <Route path={ROUTES.LIMITS} element={<LimitsPage />} />
            {/* Ciclo 4 — HU-15-FE, HU-16-FE Cierre de cuenta */}
            <Route path={ROUTES.CLOSURE_STATUS} element={<ClosureStatusPage />} />
            {/* Ciclo 5 — HU-29-FE Reportes */}
            <Route path={ROUTES.REPORTS} element={<ReportsPage />} />
            {/* Ciclo 5 — HU-99-FE Paquetes regulatorios */}
            <Route path={ROUTES.REGULATORY_PACKAGES} element={<RegulatoryPackagesPage />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to={ROUTES.DASHBOARD} replace />} />
      </Routes>
    </BrowserRouter>
  );
}
